//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'VySection',
  props: {
    show: {type: Boolean, default: true},
    mapping: Object,
  },
}



// WEBPACK FOOTER //
// ./src/components/basic/VySection.vue